import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  IconButton,
  Paper,
  Typography,
  Button,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { downloadAudiogramApi } from "../../../apis/oscilla.api";
import fileDownload from "js-file-download";
import OneViewBox from "../../../components/layouts/OneViewBox";

const AudiogramReport = ({ name }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [blobUrl, setBlobUrl] = useState(null);
  const [filename, setFilename] = useState("audiogram.pdf");

  useEffect(() => {
    const fetchPdf = async () => {
      if (!id) return;
      setLoading(true);
      try {
        const response = await downloadAudiogramApi({ id });
        const pdfBlob =
          response instanceof Blob
            ? response
            : new Blob([response], { type: "application/pdf" });
        const url = URL.createObjectURL(pdfBlob);
        setBlobUrl(url);
        setFilename(`${name}-audiogram.pdf`);
      } catch (err) {
        console.error("Error fetching audiogram PDF:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPdf();
    return () => {
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [id]);

  const onDownload = async () => {
    try {
      setLoading1(true);
      const response = await downloadAudiogramApi({ id });
      const pdfBlob =
        response instanceof Blob
          ? response
          : new Blob([response], { type: "application/pdf" });
      fileDownload(pdfBlob, filename);
      setLoading1(false);
    } catch (err) {
      console.error("Download error", err);
    }
  };

  return (
    <Paper sx={{ p: 2, height: "90%" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Typography variant="h6">Audiogram Report</Typography>
        <Box>
          <Button
            variant="contained"
            onClick={onDownload}
            disabled={loading || loading1}
          >
            Download
          </Button>
        </Box>
      </Box>

      {loading && (
        <OneViewBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "60vh",
          }}
        >
          <CircularProgress />
        </OneViewBox>
      )}

      {!loading && blobUrl && (
        <Box sx={{ height: "80vh" }}>
          <iframe
            title="audiogram-pdf"
            src={blobUrl}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </Box>
      )}

      {!loading && !blobUrl && (
        <OneViewBox>
          <Typography>No report available.</Typography>
        </OneViewBox>
      )}
    </Paper>
  );
};

export default AudiogramReport;
